import { cdataFetch } from "src/api/cdataFetch";
import { IUpdateOrganizationRequest } from "src/models/Accounts/IUpdateOrganizationRequest";

export function updateOrganization(request: IUpdateOrganizationRequest) {
  return cdataFetch<void>({
    url: "/account/updateOrganization",
    method: "PUT",
    body: request,
    disableImpersonation: true,
  });
}
